import React from 'react'
import ReactPlayer from 'react-player'

export interface ComeceAquiProps {
  informacoesIniciaisCurso: string
}

export const ComeceAqui: React.FC<ComeceAquiProps> = ({
  informacoesIniciaisCurso
}) => {
  if (!informacoesIniciaisCurso) return null

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        paddingTop: '56.25%' // 16:9
      }}
    >
      <ReactPlayer
        url={informacoesIniciaisCurso}
        controls
        width="100%"
        height="100%"
        style={{
          position: 'absolute',
          top: 0,
          left: 0
        }}
        config={{ vimeo: { playerOptions: { controls: true } } }}
      />
    </div>
  )
}
